import {EmbedConfirmationModalProps} from './types'
import EmbedConfirmationPromiseModalView from './EmbedConfirmationPromiseModalView'

import React from 'react'

const EmbedConfirmationPromiseModal = (props: EmbedConfirmationModalProps): React.ReactElement => <EmbedConfirmationPromiseModalView {...props} />

export default EmbedConfirmationPromiseModal
